import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import localStorage from "../../../utilities/localStorage";
import { LOCALSTORAGE_MODULE_PRICING_LEVELS } from "../../../utilities/modulePricingUtils";
import { requestProductModulePricingLevels } from "../../../stores/products/ProductsAction";
import ModulePricingLevelModel from "../../../models/modulePricing/ModulePricingLevelModel";
import { useModulePricing } from "../../../hooks/useModulePricing";


export const ModulePricing: React.FunctionComponent = (
) => {
    const dispatch = useDispatch();
    const {useGetModulePricingProducts} = useModulePricing();
    // for now, all the products have the same module pricing, so take the first one
    const getModulePricingProduct = useGetModulePricingProducts()?.[0]; 
    
    const modulePricingLevelsFromState = useSelector(state => state.products?.modulePricingLevels);

    React.useEffect(() => {
        if (getModulePricingProduct) {
            dispatch(requestProductModulePricingLevels(getModulePricingProduct));
        }
    }, [dispatch, getModulePricingProduct]);

    let modulePricingLevels: any[];

    if (modulePricingLevelsFromState) {
        modulePricingLevels = Object.values(modulePricingLevelsFromState).map((level: ModulePricingLevelModel) => ({
            lowLimit: level.lowLimit,
            highLimit: level.highLimit,
            modulePrice: level.modulePrice
        }));
    }

    useEffect(() => {
        if (modulePricingLevels?.length > 0) {
            localStorage.setJsonItem(LOCALSTORAGE_MODULE_PRICING_LEVELS, modulePricingLevels);
        }
        // eslint-disable-next-line
    }, [modulePricingLevels]);

    return null;
};
